import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {initializeConnector, useWeb3React, Web3ReactProvider} from "@web3-react/core";
import {MetaMask} from "@web3-react/metamask";
import Mint from "./components/Mint";

const config = {
    chainId: 109
}

function App() {
    const Metamask = initializeConnector<MetaMask>((actions) => new MetaMask({ actions }))
    return (
      <Web3ReactProvider connectors={[Metamask]}>
        <div className="App">
            <Mint />
        </div>
      </Web3ReactProvider>
    );
}

export default App;
